import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router";
import salesIcon from "../assets/icons/sales.png";
import supportIcon from "../assets/icons/support.png";
import visitIcon from "../assets/icons/location.png";
import whatsappIcon from "../assets/icons/connect.png";
import Contact from "./Contact";
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import gsap from "gsap";
import axios from "axios";

const ContactUs = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const salesEmail = isUAEPath
    ? "ceo@timewatchuae.com"
    : "sales@timewatchindia.com";
  const salesText = isUAEPath
    ? "Connect With Our Team"
    : "Connect With Sales Team";
  const subsalestext = isUAEPath
    ? "Looking For Solutions? Talk to Us!"
    : "Looking For Solutions? Talk to Sales!";

  const phone = isUAEPath ? "+971-54-777-0637" : "+91-95999 53923";

  const handleButtonClick = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      // POST request to your backend route
      const response = await axios.post("https://api.mytimewatch.com/api/subscribe", {
        email,
      });

      setMessage(response.data.message);
    } catch (error) {
      const errorDetail = error.response?.data?.title;
      if (errorDetail?.includes("Member Exists")) {
        setMessage("You are already subscribed!");
      } else {
        setMessage("You are already subscribed!");
      }
    }

    // Display message for 3 seconds
    setTimeout(() => setMessage(""), 3000);

    const timeline = gsap.timeline();

    // Move to the left end
    timeline.to("#subscribeButton", {
      x: "-210%",
      duration: 0.6,
      ease: "power3.out",
    });

    // Return to the original position and clear form after a short delay
    timeline.to("#subscribeButton", {
      x: "0%",
      duration: 0.6,
      ease: "power3.out",
      delay: 0.3,
      onComplete: () => {
        setEmail(""); // Clear the form field after animation
      },
    });
  };

  // Helper function to handle message display
  const showMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 3000); // Message disappears after 3 seconds
  };

  return (
    <>
      {/* Hero Section */}
      <div
        className="mb-0"
        style={{
          background: "linear-gradient(to bottom, #FCE2E2, #ffffff)",
          minHeight: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container>
          <Row>
            <Col className="text-center fw-bold">
              <h1 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                CONTACT US
              </h1>
              <p style={{ fontStyle: "italic", fontSize: "1.2rem" }}>
                We’re Just a Message Away – Reach Out Anytime, We’re Here to
                Help!
              </p>
            </Col>
          </Row>
        </Container>

        {/* Contact Info Boxes */}
      </div>

      {/* Padding for the overlapping section */}
      {/* <div style={{ marginTop: "70px" }}></div> */}
      <div className="mt-0">
        <Contact />
      </div>

      <div className="h-100 d-flex align-items-center justify-content-center mb-5">
        <section className="contact-info-boxes container">
          <Row className="justify-content-center g-4 text-center">
            {/* Card 1 */}
            <Col xs={12} sm={6} md={3}>
              <a
                href={`mailto:${salesEmail}`}
                className="text-decoration-none"
                style={{ color: "black" }}
              >
                <div
                  className="p-3 border rounded bg-white position-relative d-flex flex-column"
                  style={{ height: "180px" }}
                >
                  <img
                    src={salesIcon}
                    alt="Sales Icon"
                    className="position-absolute"
                    style={{ top: "10px", left: "10px", width: "35px" }}
                  />
                  <div className="text-start mt-5">
                    <h4 className="mb-1">{salesText}</h4>
                    <p className="mb-3 fw-bold" style={{ fontSize: "12px" }}>
                      {subsalestext}
                    </p>
                  </div>
                  <p
                    className="text-start mb-0 text-decoration-underline fw-bold"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                      fontSize: "15px",
                    }}
                  >
                    {salesEmail}
                  </p>
                </div>
              </a>
            </Col>

            {/* Card 2 */}
            {!isUAEPath && (
              <Col xs={12} sm={6} md={3}>
                <a
                  href={`mailto:support@timewatchindia.com`}
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div
                    className="p-3 border rounded bg-white position-relative d-flex flex-column"
                    style={{ height: "180px" }}
                  >
                    <img
                      src={supportIcon}
                      alt="Support Icon"
                      className="position-absolute"
                      style={{ top: "10px", left: "10px", width: "35px" }}
                    />
                    <div className="text-start mt-5">
                      <h4 className="mb-1">Connect With Support Team</h4>
                      <p className="mb-4 fw-bold" style={{ fontSize: "12px" }}>
                        Need Help? Reach Support!
                      </p>
                    </div>
                    <p
                      className="text-start mb-0 text-decoration-underline fw-bold"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        fontSize: "15px",
                      }}
                    >
                      support@timewatchindia.com
                    </p>
                  </div>
                </a>
              </Col>
            )}

            {/* Card 3 */}
            {!isUAEPath && (
              <Col xs={12} sm={6} md={3}>
                <a
                  href="https://maps.app.goo.gl/e27BDUXwoioQxPEB9"
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div
                    className="p-3 border rounded bg-white position-relative d-flex flex-column"
                    style={{ height: "180px" }}
                  >
                    <img
                      src={visitIcon}
                      alt="Visit Icon"
                      className="position-absolute"
                      style={{ top: "10px", left: "10px", width: "35px" }}
                    />
                    <div className="text-start mt-5">
                      <h4 className="mb-1">Visit Us</h4>
                      <p className="mb-4 fw-bold" style={{ fontSize: "12px" }}>
                        Want to Visit? Stop By!
                      </p>
                    </div>
                    <p
                      className="text-start mb-0 text-decoration-underline fw-bold"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        fontSize: "15px",
                      }}
                    >
                      View On Google Maps
                    </p>
                  </div>
                </a>
              </Col>
            )}

            {/* Card 4 */}
            <Col xs={12} sm={6} md={3}>
              <a
                href={`tel:${phone}`}
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <div
                  className="p-3 border rounded bg-white position-relative d-flex flex-column"
                  style={{ height: "180px" }}
                >
                  <img
                    src={whatsappIcon}
                    alt="WhatsApp Icon"
                    className="position-absolute"
                    style={{ top: "10px", left: "10px", width: "35px" }}
                  />
                  <div className="text-start mt-5">
                    <h4 className="mb-1">Connect With Us</h4>
                    <p className="mb-2 fw-bold" style={{ fontSize: "12px" }}>
                      Questions? Let’s Connect!
                    </p>
                  </div>
                  <p
                    className="text-start mb-0 text-decoration-underline fw-bold"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                      fontSize: "15px",
                    }}
                  >
                    {phone}
                  </p>
                </div>
              </a>
            </Col>
          </Row>
        </section>
      </div>
      <div
        className="mb-0"
        style={{
          background: "linear-gradient(to bottom, #FCE2E2, #ffffff)",
          minHeight: "20vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Container>
          <Row className="d-flex justify-content-center align-items-center text-center text-md-start">
            {/* Left Column */}
            <Col md={6} xs={12} className="mb-3 mb-md-0 fw-bold">
              <p
                style={{
                  fontStyle: "italic",
                  color: "#f14144",
                  fontSize: "1.5rem",
                }}
              >
                Get the Latest Updates Delivered to Your Inbox!
              </p>
            </Col>

            {/* Right Column */}
            <Col md={6} xs={12}>
              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "400px", // Optional width adjustment
                  margin: "0 auto",
                }}
              >
                <div
                  id="emailField"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    transition: "transform 0.5s ease-in-out",
                    width: "100%",
                  }}
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="email"
                      placeholder="Email..."
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        padding: "0.5rem 1.5rem 0.5rem 0.5rem",
                        border: "2px solid #FFBCBC",
                        borderRadius: "100px",
                        backgroundColor: "white",
                        width: "100%",
                      }}
                    />
                    <button
                      id="subscribeButton"
                      className="fw-bold"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "0px",
                        transform: "translateY(-50%)",
                        backgroundColor: "#FDF0F0",
                        color: "#f14144",
                        border: "2px solid #FFBCBC",
                        padding: "0.6rem 1rem",
                        borderRadius: "100px",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                      }}
                      onClick={handleButtonClick}
                    >
                      Subscribe Now
                    </button>
                  </div>
                </div>
                {message && <p style={{ color: "#f14144" }}>{message}</p>}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div
        className="mb-5"
        style={{
          background: "#ffffff",
          minHeight: "40vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative", // Required for overlapping
        }}
      >
        <MDBContainer className="mt-5" style={{ maxWidth: "700px" }}>
          <h2 className="mt-0 mb-5" style={{ color: "black" }}>
            Frequently Asked Questions
          </h2>
          <MDBAccordion>
            <MDBAccordionItem
              collapseId={1}
              headerTitle="What services does TimeWatch Infocom provide?"
            >
              TimeWatch Infocom specializes in Biometric Time Attendance
              Systems, Access Control solutions, Parking and Traffic Management
              Technologies, Inspection Control solutions, Entrance Control
              Solutions to enhance workplace security and efficiency.
            </MDBAccordionItem>
            <MDBAccordionItem
              collapseId={2}
              headerTitle="Do you offer installation and support services?"
            >
              Yes, we provide end-to-end solutions, including installation,
              training, and ongoing technical support to ensure seamless
              operation of our products.
            </MDBAccordionItem>
            <MDBAccordionItem
              collapseId={3}
              headerTitle="Can your solutions be customized for specific business needs?"
            >
              Absolutely! Our products and software can be tailored to meet the
              unique requirements of different industries and organizations.
            </MDBAccordionItem>
            <MDBAccordionItem
              collapseId={4}
              headerTitle="What industries do you serve?"
            >
              We cater to a wide range of industries, including corporate
              offices, manufacturing units, educational institutions, and
              government organizations.
            </MDBAccordionItem>
            <MDBAccordionItem
              collapseId={5}
              headerTitle="How can I request a demo or get a quotation?"
            >
              You can contact us via phone, email, or through the enquiry form
              on our website to request a demo or receive a personalized
              quotation.
            </MDBAccordionItem>
          </MDBAccordion>
        </MDBContainer>
      </div>
    </>
  );
};

export default ContactUs;
